import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/bitacora';
import DetalleBitacora from './DetalleBitacora';

const mstp = state => {
    return {...state.bitacora}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(DetalleBitacora)
